import React from 'react'
import { Modal } from 'react-bootstrap'

// HTML: #deleteConfirmModal — .modal-card > h2 + p.lead + .modal-actions
const DeleteOptionModal = ({
  show,
  onHide,
  optionText,
  dependentQuestions,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop='static'
      keyboard={false}
      dialogClassName='experience-confirm-dialog'
      contentClassName='experience-confirm-card'>
      <Modal.Body className='p-0'>
        <div className='experience-confirm-body'>
          <h2>Can&rsquo;t delete this option</h2>
          <p className='experience-confirm-lead'>
            <strong>&ldquo;{optionText}&rdquo;</strong> cannot be deleted
            because it is being used by the following dependent question(s):
          </p>
          <ul>
            {dependentQuestions.map((question, index) => (
              <li key={index}>
                <strong>Question {question.displayNumber}: </strong>
                {question.text}
              </li>
            ))}
          </ul>
          <p className='experience-confirm-lead mb-0'>
            Please remove the dependency first, or modify the dependent
            question&apos;s condition before deleting this option.
          </p>
          <div className='experience-modal-actions'>
            <button type='button' className='btn-navy' onClick={onHide}>
              Ok
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default DeleteOptionModal
